import React, { useEffect, useState } from "react";
import axios from "axios";
import NoListProv from "./NoListProv/NoListComer";

import "./ListSalesComer.css";
import { FaClipboardList } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import NabvarComercializadorLealtad from "../NavbarSupplierLealtad/NavbarSupplierLealtad";
import FooterIndex from "../../components/footerHomePage/footerHomePage";

const ListProv = () => {
  const [salesData, setSalesData] = useState(null);
  const [load, setLoad] = useState(true);

  const location = useLocation();
  let data = location.state;

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  useEffect(() => {
    setLoad(true);
    const id = data.id;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BRING_SEARCH_INVOICE_COMERCIALIZADOR_LEALTAD}?id=${id}`
        );

        if (response.status === 204) {
          setLoad(false);
          setSalesData(null);
        } else {
          setLoad(false);
          setSalesData(response.data.invoiceValue);
        }
      } catch (error) {
        setLoad(false);
        setSalesData(null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <NabvarComercializadorLealtad />

      {!load ? (
        <>
          {salesData !== null ? (
            <div>
              <div className="backgounrdproveelealtad">
                <div className="allboxlistprovlealtad">
                  <div className="alllistprovlealtad">
                    <div className="headerlistprovlealtad">
                      <p className="infoprovlistletterlealtad leftlistprevlealtad firsttittlelealtad">
                        Mes
                      </p>
                      <p className="infoprovlistletterlealtad leftlistprevlealtad">
                        Nº Factura
                      </p>
                      <p className="infoprovlistletterlealtad leftlistprevlealtad">
                        Total
                      </p>
                      <p className="infoprovlistletterlealtad leftlistprevlealtad">
                        CBU
                      </p>
                      <p className="infoprovlistletterlealtad leftlistprevlealtad">
                        Observaciones
                      </p>
                      <p className="infoprovlistletterlealtad leftlistprevlealtad lastittlelealtad">
                        Estado
                      </p>
                    </div>

                    {salesData &&
                      salesData.map((sale, index) => (
                        <div className="headerlistprovlealtad" key={index}>
                          <p className="infoprovlistletterlealtad leftlistprev2lealtad firsttittlelealtad">
                            {sale.month}
                          </p>
                          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                            {sale.numberInvoice}
                          </p>
                          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                            ${sale.amountToBeTransferred}
                          </p>
                          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                            {sale.cbu}
                          </p>
                          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                            {sale.observation}
                          </p>
                          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                            {sale.invoice}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <NoListProv
              title="La información de este mes no se ha subido aún."
              Icon={FaClipboardList}
            />
          )}
          <FooterIndex />
        </>
      ) : (
        <div className="loaderlealtad"></div>
      )}
    </>
  );
};

export default ListProv;
